import { Maybe } from 'graphql/jsutils/Maybe';

import { defined } from '../../../utils/defined';

const re = /^\d{1,4}$/;

export const validateStoreHoursString = (
	storeHours: Maybe<string> | undefined
): storeHours is string =>
	defined(storeHours) &&
	storeHours !== '' &&
	typeof storeHours === 'string' &&
	re.test(storeHours) &&
	Number(storeHours) >= 0 &&
	Number(storeHours) <= 2400 &&
	Number(storeHours) % 100 < 60;
